import styled from 'styled-components'
import { COLOURS } from 'resources'

export const Container = styled.div`
  margin-bottom: 26px;
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  line-height: 1;
  font-size: 36px;
  margin-bottom: 8px;
  margin-top: 16px;
`

export const Description = styled.div`
  color: ${COLOURS.darkGrey8};
  font-size: 18px;
  margin-bottom: 1rem;
`
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
